//	P R O P S

export interface props___ComOverlayComponent {

}

//	S T A T E

export interface state___ComOverlayComponent {

	overlay___isActive: boolean,

}

//	S T A T E   D E F A U L T

export const state___ComOverlayComponent___default: state___ComOverlayComponent = {

	overlay___isActive: true,

}